exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".login-widget,.login-widget .message,.login-widget .title{margin:auto;text-align:center;padding:1em;font-size:20px}.login-widget .message{margin-top:1em}.login-widget input{padding:.5em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-5d657888!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/login-page.vue
// module id = 90
// module chunks = 0